(() => {
  'use strict';
  const shelves = document.querySelectorAll('[data-xp-commerce]');
  const updateCount = (shelf) => {
    const badge = document.querySelector('[data-xp-shop-count]');
    const count = Number(shelf.dataset.productCount);
    if (!badge || !count) return;
    badge.textContent = badge.dataset.countLabel.replace('__COUNT__', String(count));
    badge.hidden = false;
  };
  shelves.forEach(updateCount);
  const load = async (shelf) => {
    if (shelf.dataset.loaded || Number(shelf.dataset.productCount) > 0) return;
    shelf.dataset.loaded = 'true';
    const subject = shelf.dataset.subject;
    if (!subject || subject.length > 100) return;
    const url = new URL(shelf.dataset.searchUrl, window.location.origin);
    url.search = new URLSearchParams({type: 'product', q: subject, view: 'xp-products', 'options[unavailable_products]': 'hide'}).toString();
    try {
      const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(8000)});
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const products = Array.from(doc.querySelectorAll('[data-xp-commerce-results] > .zxp-product')).slice(0, 4);
      if (!products.length) return;
      const grid = shelf.querySelector('[data-xp-commerce-grid]');
      grid.replaceChildren(...products);
      grid.style.setProperty('--xp-product-columns', String(products.length));
      grid.hidden = false;
      shelf.dataset.productCount = String(products.length);
      updateCount(shelf);
      shelf.querySelector('[data-xp-commerce-intro]').textContent = shelf.dataset.matches;
    } catch (_) {}
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    }, {rootMargin: '800px'});
    shelves.forEach((shelf) => observer.observe(shelf));
  } else {
    shelves.forEach(load);
  }
})();
